import cn from 'classnames'
import { ButtonProps } from './interface'

export function Button({
  isDarkTheme,
  isActive,
  children,
  onClick,
}: ButtonProps) {
  return (
    <button
      type='button'
      className={cn('w-[30px] h-[30px] border rounded-[4px]', {
        'bg-dark-4': isDarkTheme,
        'bg-white': !isDarkTheme,
        'border-primary shadow-2': isActive,
        'text-primary': isActive && isDarkTheme,
        'opacity-60': !isActive,
        'border-gray-16 text-gray-16': !isActive && isDarkTheme,
        'border-gray-3': !isActive && !isDarkTheme,
      })}
      onClick={onClick}
    >
      {children}
    </button>
  )
}
